// order-manager.component.ts

import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrderService } from '@app/shared/services/order.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-order-manager',
  templateUrl: './order-manager.component.html',
  styleUrls: ['./order-manager.component.css']
})
export class OrderManagerComponent implements OnInit {

  orderList: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 15;
  searchText: string = '';
  selectedOrder: any;
  showreConfirmationForm: boolean = false;
  reConfirmationForm: FormGroup;
  orderId: string;
  isConfirming: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private orderService: OrderService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.reConfirmationForm= this.formBuilder.group({
      reConfirmDepartment: [''],
      reConfirmSignature: [''],
    });
  }

  ngOnInit(): void {
    console.log('URL Params:', this.activatedRoute.snapshot.params);
    this.getAllOrder();

    this.activatedRoute.params.subscribe((params) => {
      console.log('Route Params:', params);
      const orderId = params['id'];
      if (orderId) {
        this.orderId = orderId;
        // this.updateOrder(this.orderId);
        this.showTable = false;
      } else {
        // console.error('OrderId is undefined or null in route parameters.');
      }
    });
  }

  getAllOrder() {
    this.orderService.getOrder().subscribe(
      (res: any) => {
        // Filter out the confirmed orders from the orderList
        this.orderList = res.filter((order) => order.status == 'Reconfirm');
        console.log(this.orderList);
        this.orderList.reverse();
        this.cdr.detectChanges();
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  // updateOrder(id: any) {
  //   this.orderService.getOrderById(id).subscribe(
  //     (res: any) => {
  //       this.editOrderForm.patchValue(res);
  //     },
  //     (err: any) => {
  //       console.log(err);
  //     }
  //   );
  // }

  openReconfirmationForm(order: any): void {
    if (order.status === 'Reconfirm' && !order.reconfirmed) {
      this.selectedOrder = order;
      this.showreConfirmationForm = true;
    } else {
      console.log('This order cannot be reconfirmed as it is not in "Confirmed" status or already reconfirmed.');
    }
  }
  

 

  

  showTable = true;

  get paginatedClients(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.orderList
      .filter((client) => this.matchesSearch(client))
      .slice(startIndex, endIndex);
  }

  getNumberRange(end: number): number[] {
    return Array.from({ length: end }, (_, index) => index + 1);
  }

  ceil(value: number): number {
    return Math.ceil(value);
  }

  get totalItems(): number {
    return this.orderList.filter((client) => this.matchesSearch(client)).length;
  }

  calculateRangeStart(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  calculateRangeEnd(): number {
    return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  onSearch(): void {
    this.currentPage = 1; // Reset to the first page when performing a new search
  }

  private matchesSearch(client: any): boolean {
    const searchFields = ['clientName', 'email', 'contactNo'];
    const lowerCaseSearch = this.searchText.toLowerCase();

    return searchFields.some((field) => {
      const fieldValue = client[field];
      if (fieldValue && typeof fieldValue === 'string') {
        return fieldValue.toLowerCase().includes(lowerCaseSearch);
      }
      return false;
    });
  }

  deleteSelectedEntries() {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    const selectedIds = [];
    
    checkboxes.forEach((checkbox) => {
      if ((checkbox as HTMLInputElement).checked) {
        selectedIds.push((checkbox as HTMLInputElement).dataset.id); // Assuming dataset.id is used for ID
      }
    });

    if (selectedIds.length > 0) {
      // this.orderService.deleteAllTechOrder(selectedIds).subscribe(
      //   (response) => {
      //     console.log('Entries deleted successfully:', response);
      //     // Optionally update your client list after deletion
      //     this.getAllOrder(); // Example method to fetch clients again
      //   },
      //   (error) => {
      //     console.error('Error deleting entries:', error);
      //     // Handle error in UI or show error message
      //   }
      // );
    } else {
      console.log('No entries selected for deletion');
      // Handle case where no entries are selected
    }
  }

  selectAllChanged(event: Event) {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    checkboxes.forEach((checkbox) => {
      (checkbox as HTMLInputElement).checked = (event.target as HTMLInputElement).checked;
    });
  }
}
